import { REFERRAL_SET, REFERRAL_UNSET } from '../action_constants'

export function removeReferral() {
  return { type: REFERRAL_UNSET }
}

export function setReferral(data) {
  return { type: REFERRAL_SET, payload: data }
}
